import { create } from 'zustand';

interface LoginFormDialogState {
    isOpen: boolean;
    action: {
        setIsOpen: (open: boolean) => void;
    };
}

export const useLoginFormDialogStore = create<LoginFormDialogState>((set) => ({
    isOpen: false,
    action: {
        setIsOpen: (open: boolean) => set({ isOpen: open }),
    },
}));

export default useLoginFormDialogStore;
